module.exports = __webpack_public_path__ + "static/artcoco-ce8c27eaf121d5b91ce1d9e2c2fba1c4.jpg";